<template>
	<div class="notData flex_d_c_c" :class="{'mobileaiTitlePage': isMobile}">
		<!-- 没有数据 -->
		<img v-if="imgType == 1" src="@img/common/kong.png" class="notImg" alt="">
		<img v-if="imgType == 2" class="weigoumaiImg" src="@img/detail/weikaishi.png" alt="" />
		<img v-if="imgType == 3" class="gantanImg" src="@img/detail/gantao.png" alt="" />
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'NotData',
		props: {
			imgType: {
				type: Number,
				default: 1
			}
		},
		data() {
			return {
				isMobile: this.$store.state.screenData?.isMobile,
			}
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="less">
	.notData {
		padding: 100px 0;
		
		p {
			margin: 30px 0;
			color: #909399;
			font-size: 16px;
		}
		
		.notImg {
			width: 30%;
			max-width: 200px;
		}
		
		.weigoumaiImg {
			width: 200px;
			max-width: 80%;
		}
		.gantanImg {
			width: 40px;
		}
	}
	.mobileaiTitlePage {
		padding: 100PX 0;
		
		p {
			margin: 30PX 0;
			color: #909399;
			font-size: 16PX;
		}
		
		.notImg {
			width: 30%;
			max-width: 200PX;
		}
		
		.weigoumaiImg {
			width: 120PX;
		}
		.gantanImg {
			width: 40PX;
		}
	}
</style>